import { render, staticRenderFns } from "./dialogRoleList.vue?vue&type=template&id=72351b48&scoped=true"
import script from "./dialogRoleList.vue?vue&type=script&lang=js"
export * from "./dialogRoleList.vue?vue&type=script&lang=js"
import style0 from "./dialogRoleList.vue?vue&type=style&index=0&id=72351b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72351b48",
  null
  
)

export default component.exports